import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {Observable, Subject} from "rxjs";
import moment from "moment/moment";
import Swal from "sweetalert2";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private apiURL = environment.apiBaseUrl + '/auth';
  private isAuthenticated = false;
  private token: string | undefined;
  private tokenTimer: any;
  private authStatusListener = new Subject<boolean>();
  private currentDate = moment().format('YYYY-MM-DD');

  constructor(private http: HttpClient, private router: Router) { }

  getToken() {
    return this.token;
  }

  getIsAuth() {
    return this.isAuthenticated;
  }

  getAuthStatusListener() {
    return this.authStatusListener.asObservable();
  }

  resetPassword(email: string): Observable<any> {
    return this.http.post(`${this.apiURL}/reset-admin-password`, {email: email});
  }

  changePassword(oldPassword: string, newPassword: string): Observable<any> {
    return this.http.post(`${this.apiURL}/change-password`, {oldPassword: oldPassword, newPassword: newPassword});
  }

  login(email: string, password: string) {
     this.http.post<{ token: string, expiresIn: number }>(`${this.apiURL}/login`, {email: email, password: password})
       .subscribe( {
         next: (response) => {
           this.token = response.token;
           if (this.token) {
             const expiresInDuration = response.expiresIn;
             this.setAuthTimer(expiresInDuration);
             this.isAuthenticated = true;
             this.authStatusListener.next(true);
             const expirationDate = new Date(Date.now() + expiresInDuration * 1000);
             this.saveAuthData(this.token, expirationDate);
             this.router.navigate(['/calendario/' + this.currentDate]);
           }
         },
         error: (error) => {
           console.log(error);

           Swal.fire({
             icon: 'error',
             title: 'Ops...',
             text: error.error.message,
             confirmButtonColor: '#050A30'
           });

           this.authStatusListener.next(false);
         }
       })
  }

  autoAuthUser() {

    const authInformation = this.getAuthData();
    if (!authInformation){
      return;
    }

    const now = new Date();
    const expiresIn = authInformation.expirationDate.getTime() - now.getTime();

    if (expiresIn > 0) {
      this.token = authInformation.token;
      this.isAuthenticated = true;
      this.authStatusListener.next(true);
      this.setAuthTimer(expiresIn / 1000);
    }
  }

  logout() {
    this.token = undefined;
    this.isAuthenticated = false;
    this.authStatusListener.next(false);
    clearTimeout(this.tokenTimer);
    this.clearAuthData();
    this.router.navigate(['/login']);
  }

  private saveAuthData(token: string, expirationDate: Date){
    localStorage.setItem('token', token);
    localStorage.setItem('expiration', expirationDate.toISOString());
  }

  private clearAuthData(){
    localStorage.removeItem('token');
    localStorage.removeItem('expiration')
  }

  private getAuthData(){
    const token = localStorage.getItem('token');
    const expiration = localStorage.getItem('expiration');

    if (!token || !expiration){
      return;
    }
    return{
      token: token,
      expirationDate: new Date(expiration)
    }
  }

  private setAuthTimer(duration: number){
    this.tokenTimer = setTimeout(() => {
      this.logout();
    }, duration * 1000);
  }
}
